/**
 * setCookie
 *
 * @param {*} cname
 * @param {*} cvalue
 * @param {*} exdays - if left as 0 the cookie will expire after browser is closed.
 */
export function setCookie(cname, cvalue, exdays = 0) {
  let expires = "";

  if (exdays > 0) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    expires = `expires=${d.toUTCString()};`;
  }

  const cookieString = `${cname}=${cvalue};${expires}path=/`;
  document.cookie = cookieString;
}

/**
 *
 * @param {*} cname
 * @returns
 */
export function getCookie(cname) {
  const name = `${cname}=`;
  const ca = typeof document !== 'undefined' && document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
